import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faEdit, faPrint } from '@fortawesome/free-solid-svg-icons';
import { Constants } from 'src/app/common';
import { ITemplateDocument } from 'src/app/models/i-template-document';
import { ITemplateType } from 'src/app/models/i-template-type';
import { AlertsService } from 'src/app/services/alerts.service';
import { BlockUiHandlerService } from 'src/app/services/block-ui-handler.service';
import { StorageService } from 'src/app/services/storage.service';
import { TemplatesService } from 'src/app/services/templates.service';
import { FilesService } from '../../services/files.service';
import { CommonService } from '../../services/common.service';
import { TEMPLATES } from 'src/app/common/constants';

@Component({
  selector: 'app-view-template-documents',
  templateUrl: './view-template-documents.component.html',
  styleUrls: ['./view-template-documents.component.css']
})
export class ViewTemplateDocumentsComponent implements OnInit {
  CurrentPage: number = 1;
  PageSize: number = 8;
  CollectionSize: number = 1;

  SearchForm: FormGroup;

  TemplateDocuments: ITemplateDocument[];
  TemplateTypes: ITemplateType[];

  search: boolean;

  constructor(
    private templatesService: TemplatesService,
    private filesService: FilesService,
    private blockUiHanddler: BlockUiHandlerService,
    private alertsService: AlertsService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    library: FaIconLibrary
  ) {
    library.addIcons(faEdit, faPrint)
  }

  ngOnInit(): void {
    this.InitVariables();
    this.ResetSearchForm();
    this.LoadTemplateTypes();
    this.LoadTemplateDocumentsPagedCount();
  }

  InitVariables(): void {
    this.search = false;
    this.TemplateDocuments = [];
    this.TemplateTypes = [];
  }

  LoadTemplateTypes(){
    this.blockUiHanddler.Start(1, 'Cargando tipos de formatos...')
    this.templatesService.GetTemplateTypes().subscribe(req => {
      this.blockUiHanddler.Stop();
      if(req.Result){
        this.TemplateTypes = req.Data;
      } else {
        this.alertsService.ShowSmallCornerAlert('Ocurrió un error al cargar los Templates', 2)
      }
    }, err => {
      this.blockUiHanddler.Stop();
      this.alertsService.ShowSmallCornerAlert(err, 2);
    });
  }

  ResetSearchForm(): void {
    let LastMonthDate = new Date();
    LastMonthDate.setMonth(LastMonthDate.getMonth() - 1);
    let MonthDate = formatDate(LastMonthDate, 'yyyy-MM-dd', 'en');
    let NowDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.SearchForm = this.formBuilder.group({
      Name: [''],
      CreateUser: [''],
      UpdateUser: [''],
      From: [MonthDate, Validators.required],
      To: [NowDate, Validators.required],
      TemplateType: ['']
    });
  }

  LoadTemplateDocumentsPagedCount(){
    this.search = false;
    this.blockUiHanddler.Start(1, 'Cargando paginación de formatos...');
    this.templatesService.GetTemplateDocumentsCount(
      this.SearchForm.controls['Name'].value,
      this.SearchForm.controls['CreateUser'].value,
      this.SearchForm.controls['UpdateUser'].value,
      this.SearchForm.controls['From'].value,
      this.SearchForm.controls['To'].value,
      this.SearchForm.controls['TemplateType'].value
      ).subscribe(req => {
        this.blockUiHanddler.Stop()
        if(req.Result){
          this.CollectionSize = req.Data;
          this.LoadTemplateDocuments();
        }
      }, err => {
        this.blockUiHanddler.Stop()
        this.alertsService.ShowSmallCornerAlert(err, 2)
      });
  }

  LoadTemplateDocuments(){
    this.blockUiHanddler.Start(1, 'Cargando formatos guardados...')
    this.templatesService.GetTemplateDocumentsPaged(
      this.SearchForm.controls['Name'].value,
      this.SearchForm.controls['CreateUser'].value,
      this.SearchForm.controls['UpdateUser'].value,
      this.SearchForm.controls['From'].value,
      this.SearchForm.controls['To'].value,
      this.SearchForm.controls['TemplateType'].value,
      ((this.CurrentPage*this.PageSize)-this.PageSize),
      this.PageSize
    ).subscribe(req => {
      this.blockUiHanddler.Stop()
      if(req.Result){
        this.TemplateDocuments = req.Data;
      }
    }, err => {
      this.blockUiHanddler.Stop()
      this.alertsService.ShowSmallCornerAlert(err, 2)
    });
  }

  SelectPage(Page: string): void {
    this.CurrentPage = (parseInt(Page, 10) || 1);
  }

  FormatInput(input: HTMLInputElement): void {
    input.value = input.value.replace(Constants.FILTER_PAG_REGEX, '');
  }

  GetTemplateName(TemplateDocument: ITemplateDocument): string{
    let Variables: { [name: string]: string } = JSON.parse(TemplateDocument.JsonVariables)
    
    if(TemplateDocument.DocumentType.TemplateType.Name === TEMPLATES.FIDEICOMISO){
      return Variables['bac.nombre_Fideicomiso'];
    }
    else if(TemplateDocument.DocumentType.TemplateType.Name === TEMPLATES.HIPOTECA){
      return Variables['tse.nombre_deudor'];
    }
    else if(TemplateDocument.DocumentType.TemplateType.Name === TEMPLATES.PRENDAS){
      return Variables['bac.nombre_Prenda'];
    }
    else{
      return "";
    }
  }

  ValidateDate(fieldKey: string){
    this.search = true;
    let NowDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    if(!this.SearchForm.controls[fieldKey].value) this.SearchForm.controls[fieldKey].setValue(NowDate);
    if(parseInt(formatDate(this.SearchForm.controls[fieldKey].value, 'yyyy', 'en')) > 9999) this.SearchForm.controls[fieldKey].setValue(NowDate);
  }

  Download(Document: ITemplateDocument) {
    this.blockUiHanddler.Start(1, 'Descargando formato...')
    this.filesService.DownloadDocumentFile(Document.Id).subscribe(response => {
      this.blockUiHanddler.Stop();
      if(response.Result){
        this.commonService.DownloadFile(response.Data.Base64, response.Data.Name, response.Data.Type);
      } else {
        this.alertsService.ShowSmallCornerAlert(response.ErrorInfo.Message, 3);
      }
    }, error => {
      this.blockUiHanddler.Stop();;
      this.alertsService.ShowSmallCornerAlert(error, 3);
    })
  }
}
